











































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import Loading from "./Loading.vue";
import PointerMenu from "../general/PointerMenu.vue";
import ShowMoreView from "../controls/ShowMoreView.vue";
import FormCustomInput from "../general/FormCustomInput.vue";

import CustomInputJson, { defaultCustomInputJson, validateCustomInputJson } from "../../shared/CustomInputJson";
import { CustomInputCategory } from "../../shared/CustomInputCategory";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "CustomInputInput",
  components: {
    Loading,
    PointerMenu,
    ShowMoreView,
    FormCustomInput,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Array as PropType<CustomInputJson[]>,
    label: {
      type: String,
      default: "Felder",
    },
    showPublicIcon: Boolean,
    pointerMenu: String,
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customId: {
      default: "0",
    },
    category: String as PropType<CustomInputCategory>,
    editable: Boolean,
    validation: Array,
    submitValidation: Boolean,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      details: null as CustomInputJson[] | null,
      showAddCategoryType: false as boolean,
      selectedCategoryTypeId: null as number | null,
      loading: false as boolean,
      toValidate: {} as any,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;
    },

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "customInputs-" + this.customId, key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    addCustomInput() {
      if (this.details != null) {
        if (this.details.length < 10) {
          this.details.push({
            ...defaultCustomInputJson(),
            category: this.category ? this.category : defaultCustomInputJson().category,
          });
        }
      }
    },

    deleteCustomInput(index: number) {
      if (this.details != null) {
        this.details.splice(index, 1);

        delete this.toValidate["images-" + index];
      }
    },
  },

  watch: {
    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
